import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/axiosInstance";

export const getSingleCurrencyFunc = createAsyncThunk(
  "getSingleCurrency",
  async (id, thunkAPI) => {
    try {
      const response = await api.get(`dashboard/currencies/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

const getSingleCurrencySlicer = createSlice({
  name: "getSingleCurrency",
  initialState: {
    loading: false,
    data: null,
    error: null,
    apiErrors: {},
    successMessage: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSingleCurrencyFunc.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.apiErrors = {};
      })
      .addCase(getSingleCurrencyFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload?.currency || null;
        state.successMessage = action.payload?.message || "";
      })
      .addCase(getSingleCurrencyFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
      });
  },
});

export default getSingleCurrencySlicer.reducer;
